module.exports = __webpack_public_path__ + "img/attachment.6471f173.svg";